import { Link } from "react-router-dom";
import { Link as ScrollLink } from "react-scroll";

export const Footer = () => {
  return (
    <footer className=" mt-20  w-full sm:px-10 xl:px-14 pt-[20px]">
      <div className="py-10 mx-10 md:text-left  mb-[30px]">
        <div className="text-center flex justify-center flex-col space-y-3">
          <p className="text-[#8F9299] font-onestMedium">Quick Links</p>
          <div className="sm:space-x-5 sm:space-y-0 space-y-3 justify-center flex sm:flex-row flex-col font-onestMedium pb-5 border-b">
            <ScrollLink className="cursor-pointer" to="how-it-works" smooth={true} duration={500}>
              How It Works
            </ScrollLink>
            <ScrollLink className="cursor-pointer" to="faq" smooth={true} duration={500}>
              FAQs
            </ScrollLink>
            <ScrollLink className="cursor-pointer" to="location" smooth={true} duration={500}>
              Locations
            </ScrollLink>
            <ScrollLink className="cursor-pointer" to="terms-and-condition" smooth={true} duration={500}>
              Terms and Conditions
            </ScrollLink>
          </div>
          <div className="flex justify-center">
            <Link to="https://www.fezdelivery.co/">
              <img src="images/footerlogo.svg" alt="footer-icon" className="h-20 w-20" />
            </Link>
          </div>
        </div>
      </div>
    </footer>
  );
};
